'use strict';
const {GoogleSdkManager} = require('../helpers/GoogleSdkManager');
const {parseJwt} = require('../helpers/parseJwt');

var listenerConected = {};
var listenerError = {};
var facebookToken = {};
var valitationExp;
var googleBasicProfile;
var traveller = {
    buyer: false,
    typeOfTraveller: 'ADULT',
    frequentFlyerList: [],
    email: null,
    profile: {
        gender: '',
        title: '',
        name: '',
        middleName: null,
        firstLastName: '',
        secondLastName: null,
        birthDate: null,
        prefixPhoneNumber: null,
        phoneNumber: null,
        prefixAlternatePhoneNumber: null,
        mobilePhoneNumber: null,
        alternatePhoneNumber: null,
        isDefault: true,
        cpf: null,
        nationalityCountryCode: null,
        identificationList: [],
        address: null,
    },
    importedFromLocal: false,
};
var socialLoginType = {facebook: 'facebook', google: 'google'};
var facebookStatusChange = function(response, widgetIdEvent) {
    var data;
    if (response.status === 'connected') {
        facebookToken = response.authResponse.accessToken;
        data = {
            token: facebookToken,
            loginType: socialLoginType.facebook,
        };
        listenerConected[widgetIdEvent](data);
    } else {
        listenerError[widgetIdEvent](response.status === 'not_authorized' ? 'error' : 'unknown', socialLoginType.facebook);
    }
};
var googleLoginOk = function(response, widgetIdEvent) {
    var data;
    if (!response?.error) {
        data = {
            token: response?.access_token,
            loginType: socialLoginType.google,
        };
        listenerConected[widgetIdEvent](data);
    } else {
        listenerError[widgetIdEvent](response?.error === 'access_denied' ? 'error' : 'unknown', socialLoginType.google);
    }
};

const loginGis = (widgetId) =>
    GoogleSdkManager.login(
        (response) => googleLoginOk(response, widgetId),
        (response) => googleLoginError(response, widgetId)
    );

var googleLoginError = function(response, widgetIdEvent) {
    listenerError[widgetIdEvent](response.error === 'access_denied' ? 'error' : 'unknown', socialLoginType.google);
};
var validateFields = function(name, firstLastName) {
    var validationRegExp = new RegExp(valitationExp);
    return validationRegExp.test(name + firstLastName);
};
var getData = function(data, name, firstLastName, email) {
    if (data.valid) {
        Odigeo._.extend(data, {
            traveller: {
                email: email,
                profile: {
                    name: name,
                    firstLastName: firstLastName,
                    title: 'MR',
                    gender: 'MALE',
                },
            },
        });
        data.valid = true;
    }
    return data;
};
var redirectIfValidPage = function(page) {
    if (!Odigeo._.isUndefined(page)) {
        if (page === 'home') {
            Odigeo.Utils.goToApplicationHome();
        } else {
            Odigeo.Router.navigate(page);
        }
    }
};
const updateTraveller = (data, response, widgetId) => {
    const createTraveler = function(profile, email) {
        traveller.email = email;
        Odigeo._.extend(traveller.profile, profile);
        return [traveller];
    };
    const actionData = {
        action: 'updateAccountInfo',
        data: data.userDTO,
    };
    data.userDTO.traveller = createTraveler(response.traveller.profile, response.traveller.email);
    Odigeo.trigger(`${widgetId}:submitUserRequest`, actionData, true);
};

module.exports = {
    /**
     *
     * @param {function} connectedFunction Callback ok
     * @param {function} errorsFunction Callback error
     * @param {string} widgetId
     * @param {string} validateExp Validate first and last name for register when the user is new
     */
    init: function(connectedFunction, errorsFunction, widgetId, validateExp) {
        if (typeof FB === 'undefined') {
            Odigeo.require(['facebook'], function() {
                FB.init({
                    appId: Odigeo.SessionScope.social.facebookAppId,
                    cookie: true,
                    xfbml: true,
                    version: 'v3.0',
                });
            });
        }
        GoogleSdkManager.init(Odigeo.SessionScope.social.googleLoginClientId, (response) => googleLoginError(response, widgetId));
        valitationExp = validateExp;
        // add listeners functions
        listenerConected[widgetId] = connectedFunction;
        listenerError[widgetId] = errorsFunction;
    },

    socialLoginType: socialLoginType,

    getLoginStatus: function(widgetId) {
        var widgetIdEvent = widgetId;
        Odigeo.Session.set('loginWidget', widgetId);
        FB.login(Odigeo._.bind(function(response) {
            facebookStatusChange(response, widgetIdEvent);
        }, this), {scope: 'email', return_scopes: true});
    },

    getLoginStatusGoogle: (widgetId) => {
        Odigeo.Session.set('loginWidget', widgetId);
        loginGis(widgetId);
    },

    getFirstName: function(callbackFn) {
        if (!Odigeo._.isEmpty(facebookToken)) {
            this.getFacebookUserInformation(callbackFn);
        } else {
            this.getGoogleUserInformation(callbackFn);
        }
    },

    getFacebookUserInformation: function(callbackFn) {
        var validateFBFields = function(response) {
            var data = {
                valid: validateFields(response.first_name, response.last_name),
            };
            callbackFn(getData(data, response.first_name, response.last_name, response.email));
        };
        FB.api('/me', {
            fields: 'first_name,last_name,email',
            access_token: facebookToken.token,
        }, validateFBFields);
    },

    /**
     *
     * @param {function} callBackFn Callback function
     */
    getGoogleUserInformation: function(callBackFn) {
        var data = {
            valid: validateFields(googleBasicProfile.getGivenName(), googleBasicProfile.getFamilyName()),
        };
        callBackFn(getData(data, googleBasicProfile.getGivenName(), googleBasicProfile.getFamilyName(), googleBasicProfile.getEmail()));
    },

    /**
     * @param {function} callbackFn Callback function
     */
    createTraveller: function(callbackFn) {
        this.getFirstName(Odigeo._.bind(function(response) {
            var newTraveller = Odigeo._.clone(traveller);
            newTraveller.email = response.traveller.email;
            Odigeo._.extend(newTraveller.profile, response.traveller.profile);
            callbackFn(response.valid ? newTraveller : null);
        }));
    },

    addTravellerGis: (data, widgetId) => {
        google.accounts.id.initialize({
            client_id: Odigeo.SessionScope.social.googleLoginClientId,
            auto_select: true,
            callback: function({credential}) {
                const credentialParsed = parseJwt(credential);
                const userData = {
                    valid: validateFields(credentialParsed.given_name, credentialParsed.family_name),
                };
                const response = getData(userData, credentialParsed.given_name, credentialParsed.family_name, credentialParsed.email);
                response.valid && updateTraveller(data, response, widgetId);
            },
        });
        google.accounts.id.prompt();
    },

    /**
     *
     * @param {object} data
     * @param {string} widgetId
     * @param {string} navigateTo (optional)
     * @param {string} loginType (optional)
     */
    addTravellerToAccount: function(data, widgetId, navigateTo, loginType) {
        if (Odigeo._.isEmpty(data.userDTO.traveller)) {
            if (loginType === socialLoginType.facebook) {
                this.getFirstName(Odigeo._.bind(function(response) {
                    var createTraveler = Odigeo._.bind(function(profile, email) {
                        traveller.email = email;
                        Odigeo._.extend(traveller.profile, profile);
                        return [traveller];
                    }, this);
                    if (response.valid) {
                        data.userDTO.traveller = createTraveler(response.traveller.profile, response.traveller.email);
                        Odigeo.trigger(widgetId + ':submitUserRequest',
                            {action: 'updateAccountInfo', data: data.userDTO}, true);
                    } else {
                        redirectIfValidPage(navigateTo);
                    }
                }, this));
            } else {
                this.addTravellerGis(data, widgetId);
            }
        } else {
            redirectIfValidPage(navigateTo);
        }
    },
};
